$('header .toggle_menu').on('click', function(){

    console.log('GOOOOO');

    var item = $(this);
    item.toggleClass('change');
    if(item.hasClass('change')){
        $('.navbar.navbar-default').fadeIn('fast');
        $('header .quick_menu').removeClass('display');
    } else {
        $('.navbar.navbar-default').fadeOut('fast'); 
        $('header .quick_menu').addClass('display'); 
    }
}); 

var header_height = $('header').outerHeight();
$('header').addClass('fixed'); 
if(!$('header').hasClass('header_over')){
    $('body').css('padding-top', header_height + 'px');
} 

    if ($(document).scrollTop() > 400) {
        $('header').addClass('small-header');
    }
    else {
        $('header').removeClass('small-header'); 
    } 
    
    $(window).scroll(function() {
        if ($(document).scrollTop() > 400) {
            $('header').addClass('small-header');
        }
        else {
            $('header').removeClass('small-header');
        }
    });


$( window ).resize(function() {
    $('header').removeClass('small-header'); 
    var header_height = $('header').outerHeight();
    if(!$('header').hasClass('header_over')){
        $('body').css('padding-top', header_height + 'px');
    } 
});

$('header .search_form_header .search').focus(function() {
    var item = $(this);
    $('header .navbar.navbar-default').addClass('dormant');
    item.closest('.search_form_header').addClass('active');
});  

$('header .search_form_header .search').blur(function() {
    var item = $(this);
    $('header .navbar.navbar-default').removeClass('dormant');
    item.closest('.search_form_header').removeClass('active');
});